import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "Special Data",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  /****** v2 Routes  ********/
  {
    path: "/v2signin",
    name: "v2SignIn",
    component: () => import("../v2/SignIn.vue"),
    meta: {
      title: "Special Data",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/v2dashboard",
    name: "v2Dashboard",
    component: () => import("../v2/Dashboard.vue"),
    meta: {
      title: "Special Data",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },


  {
    path: "/home",
    name: "homealt",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "Special Data",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/signin",
    name: "signin",
    component: () => import("../v2/SignIn.vue"),
    meta: {
      title: "Special Data",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/confirmuser/:id/p/:password",
    name: "confirmuser",
    component: () => import("../views/ConfirmUser.vue"),
    meta: {
      title: "Special Data",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/dashboard/:action?/:id?",
    name: "dashboard",
    component: () => import("../v2/Dashboard.vue"),
    meta: {
      title: "Special Data - Dashboard",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/preferences",
    name: "preferences",
    component: () => import("../views/Preferences.vue"),
    meta: {
      title: "Special Data - Preferences",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/manageaccount/:id?",
    name: "manageaccount",
    component: () => import("../views/ManageAccount.vue"),
    meta: {
      title: "Special Data - Account",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/manageorganization/:id?",
    name: "manageorganization",
    component: () => import("../views/ManageOrganization.vue"),
    meta: {
      title: "Special Data - Organization",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/students/:id?",
    name: "students",
    component: () => import("../views/Students.vue"),
    meta: {
      title: "Special Data - Students",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/subjects",
    name: "subjects",
    component: () => import("../views/Subjects.vue"),
    meta: {
      title: "Special Data - Subjects",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
    meta: {
      title: "Special Data - Privacy Policy",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/checkemail",
    name: "checkemail",
    component: () => import("../views/CheckEmail.vue"),
    meta: {
      title: "Special Data - Check Email",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/tutorials",
    name: "tutorials",
    component: () => import("../views/Tutorials.vue"),
    meta: {
      title: "Special Data - Tutorials",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: () => import("../views/ResetPassword.vue"),
    meta: {
      title: "Special Data - Reset Password",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../views/Help.vue"),
    meta: {
      title: "Special Data - Help",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/archived",
    name: "archived",
    component: () => import("../views/Archived.vue"),
    meta: {
      title: "Special Data - Archived",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
  {
    path: "/manageTemplates",
    name: "manageTemplates",
    component: () => import("../views/DataTemplates.vue"),
    meta: {
      title: "Special Data - Templates",
      metaTags: [
        {
          name: "description",
          content:
            "Keep SPED data."
        }
      ]
    }
  },
];

const router = new VueRouter({
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;
